import { formatAmount } from 'common/formatAmount';

export const calcApportionedShares = (
  {
    legalNumberOfShares,
    legalShareCapital,
    paidUpCapitalPercentage,
  }: {
    legalNumberOfShares: number | null;
    legalShareCapital: number | null;
    paidUpCapitalPercentage: number | null;
  },
  individualNumOfShares: number | null,
) => {
  if (legalNumberOfShares === null) {
    throw new Error('legalNumberOfShares must be available');
  }
  if (legalShareCapital === null) {
    throw new Error('legalShareCapital must be available');
  }
  if (paidUpCapitalPercentage === null) {
    throw new Error('paidUpCapitalPercentage must be available');
  }

  if (
    individualNumOfShares === null ||
    individualNumOfShares > legalNumberOfShares
  ) {
    return {
      percentOfCapital: null,
      totalAmountEuros: null,
      totalAmountReleasedEuros: null,
    };
  }

  const percentOfCapital = (
    (individualNumOfShares / legalNumberOfShares) *
    100
  ).toFixed(0);
  const totalAmountEuros = formatAmount({
    forcePlusSign: false,
    value: (individualNumOfShares / legalNumberOfShares) * legalShareCapital,
  });
  const totalReleasedCoefficient = paidUpCapitalPercentage / 100;
  const totalAmountReleasedEuros = formatAmount({
    forcePlusSign: false,
    value:
      (individualNumOfShares / legalNumberOfShares) *
      legalShareCapital *
      totalReleasedCoefficient,
  });

  return {
    percentOfCapital,
    totalAmountEuros,
    totalAmountReleasedEuros,
  };
};
